document.querySelectorAll('.countdown-timer[data-end]').forEach((el) => {
  const end = new Date(el.dataset.end).getTime();

  if (Number.isNaN(end)) return;

  const clock = el.querySelector('.countdown-timer__clock');

  const tick = () => {
    const remaining = end - Date.now();

    if (remaining <= 0) {
      el.hidden = true;
      clearInterval(timer);
      return;
    }

    const days = Math.floor(remaining / 86400000);
    const hours = Math.floor((remaining % 86400000) / 3600000);
    const minutes = Math.floor((remaining % 3600000) / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);
    const pad = (value) => String(value).padStart(2, '0');

    clock.textContent = `${days}D : ${pad(hours)}H : ${pad(minutes)}M : ${pad(seconds)}S`;
    el.hidden = false;
  };

  tick();
  const timer = setInterval(tick, 1000);
});
